import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefMovesLook = 'briefmoves-row' | 'briefmoves-row-done' | 'briefmoves-deal';

const BRIEF_MOVES_LOOKS = new Set<string>(['briefmoves-row', 'briefmoves-row-done', 'briefmoves-deal']);
export const isWedgeBriefMovesLook = (look: string | undefined): look is WedgeBriefMovesLook => look !== undefined && BRIEF_MOVES_LOOKS.has(look);

/* Released Brief moves controls. The row is a checkable do-move: a full width flex row with a 12px gap, 14px 16px 14px 13px of padding, a
   3px accent edge on the left and no other edge. The caller passes the top separator and the fade-up delay because both follow the index.
   The done row is the same row dimmed to 62%. Both fade the dimming over 200ms. The deal is the Build the deal action under the close ask:
   a full width flex row with an 11px gap, 13px 14px of padding, the surface fill, a 13px radius and a 1px amber edge. The row takes the font, size, line height and ink of its parent, and left aligned text; the deal keeps the shell button font.
   None draws a transparent target or an anchor (wedgeSettingsDrawsHit):
   each already spans its whole row. */
export function wedgeBriefMovesStyle(look: WedgeBriefMovesLook): CSSProperties {
  const r = wedgeExactRole;
  switch (look) {
    case 'briefmoves-row':
    case 'briefmoves-row-done': return {
      display: 'flex', gap: 12, width: '100%', boxSizing: 'border-box', padding: '14px 16px 14px 13px',
      textAlign: 'left', background: 'none', color: 'inherit', fontFamily: 'inherit', fontSize: 'inherit', lineHeight: 'inherit',
      borderTop: 0, borderRight: 0, borderBottom: 0, borderLeft: `3px solid ${r('accent')}`,
      cursor: 'pointer', opacity: look === 'briefmoves-row-done' ? 0.62 : 1, transition: 'opacity 200ms ease',
    };
    case 'briefmoves-deal': return {
      display: 'flex', gap: 11, alignItems: 'flex-start', width: '100%', boxSizing: 'border-box', textAlign: 'left',
      cursor: 'pointer', padding: '13px 14px', background: r('surface'), borderRadius: 13, border: `1px solid ${r('amber')}`,
    };
  }
}
